export const SERVER_URL = 'api.zukdoor.com'

export const GATEWAY_URL = `https://${SERVER_URL}/gateway/api/v1`

export const ZUK_VNC_URL = `https://${SERVER_URL}/zukvnc/api/v1`
